import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { catchError, map, Observable, of, Subject, tap } from 'rxjs';
import { GS1TablePage, GS1TableState } from '@gs1france/gs1-components-library';
import { Code } from '../models/code.model';
import { Codes } from '../models/codes.model';
import { CodePriceModel } from '../../codes/models/codes-price.model';

const __URL_API__ = `${environment.URL_API}`;
const _file_name_fr = 'Certificat_Adhésion_GS1France_2021_FR';
const _file_name_en = 'Membership_Certificate_GS1France_2021_EN';

@Injectable({ providedIn: 'root' })
export class CodeService {
  public codeOrderSend = new Subject<void>();

  private _http = inject(HttpClient);

  retrievePrefixes(type: string): Observable<Code[]> {
    return this._http.get<Code[]>(__URL_API__ + 'api/Code/' + type).pipe(
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }
  retrieveCodes(type: string, record: number, page: number): Observable<Codes> {
    const query = 'record=' + record + '&page=' + page + '&type=' + type;
    return this._http.get<Codes>(__URL_API__ + 'api/Code?' + query).pipe(
      map((response) => {
        response.codes = this.completeCodes(response.codes);
        return response;
      }),
      catchError((error) => {
        console.error('Probleme de recupération de code', error);
        return of(null);
      })
    );
  }

  fetchCodes(codeType: string, state: GS1TableState<Code>): Observable<GS1TablePage<Code>> {
    const query = 'record=' + state.pageSize + '&page=' + state.pageNumber + '&type=' + codeType;
    return this._http.get<Codes>(__URL_API__ + 'api/Code?' + query).pipe(
      map((codes) => {
        const page: GS1TablePage<Code> = {
          data: codes.codes,
          totalElements: codes.count,
          ...state
        };
        page.data.map((code) => (code.plCode = !code.typeCode.startsWith('UPC') ? Math.pow(10, 12 - code.startCode.length) : Math.pow(10, 11 - code.startCode.length)));
        return page;
      })
    );
  }

  downloadCertificate(language: string): Observable<Blob> {
    const fileName = language === 'FR' ? _file_name_fr : _file_name_en;
    const query = 'langue=' + language;
    return this._http
      .get(__URL_API__ + 'api/Code/Certificate?' + query, {
        responseType: 'blob' as const
      })
      .pipe(
        tap((data) => {
          const file = new Blob([data as any], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          const a = document.createElement('a');
          a.href = fileURL;
          a.target = '_blank';
          a.rel = 'noopener';
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
        }),
        catchError((error) => {
          console.error(error);
          return of(null);
        })
      );
  }

  setLabel(code: string, label: string): Observable<boolean> {
    const formData: FormData = new FormData();
    formData.append('code', code);
    formData.append('label', label);
    return this._http.post<boolean>(__URL_API__ + 'api/Code/SetLabel', formData).pipe(
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }

  getVatAmount(priceInfo: CodePriceModel): string {
    const vatAmount = priceInfo.totalAmountHT * (priceInfo.vatPercent / 100);
    const roundedVatAmount = Math.round((vatAmount + Number.EPSILON) * 100) / 100;
    return roundedVatAmount.toFixed(2);
  }

  getNumberOf(type: string): Observable<{ count: number; countNbrProductCOL: number }> {
    return this._http
      .get<{
        count: number;
        countNbrProductCOL: number;
      }>(__URL_API__ + 'api/Code/count?type=' + type)
      .pipe(
        catchError((err) => {
          console.error("Nous n'avons pas pu récupérer votre nombre de codes", err);
          return of(null);
        })
      );
  }

  private completeCodes(codes: Code[]): Code[] {
    codes.forEach((c) => {
      //let code = +c.startCode
      c.plCode = Math.pow(10, 12 - c.startCode.length);
    });
    return codes;
  }
}
